// 资讯类型： 0:展会资讯 industry 1:行业动态 industryNews 2:展会政策 policy 3:展会知识 knowledge
enum NewsType {
  knowledge = '3',
  policy = '2',
  industryNews = '1',
  industry = '0',
}

export default NewsType;
